export const snakeCaseToCamelCase = (string: string): string =>
    string.replace(/([-_][a-z])/g, (match) =>
        match.toUpperCase().replace('-', '').replace('_', ''),
    );
